<template lang="pug">
  div
    v-card.rounded-lg.py-2.px-4.neutral200.border(outlined)
      .d-flex.justify-space-between.align-center.mb-4
        .text-lg.font-semibold +{{ phone }}
        v-btn(icon @click="handleEditInfo")
          v-icon(size="20") $yzi-edit-05
      .d-flex.justify-space-between.align-center
        .text-sm.neutral500--text.font-semibold Name
        .text-sm.neutral700--text(v-if="name") {{ name }}
        .text-sm.neutral500--text(v-else) No name
      .d-flex.justify-space-between.align-center
        .text-sm.neutral500--text.font-semibold Email
        .text-sm.neutral700--text(v-if="email") {{ email }}
        .text-sm.neutral500--text(v-else) No email
    .dialogs
      edit-info(v-if="editInfo.open" :open.sync="editInfo.open" :parent-id="memberId" :parent-name="name" :parent-phone="phone" :parent-email="email" :parent-dob="dob")
</template>

<script>
import EditInfo from "@/components/marketing/merchantapp/bottomdialogs/EditInfo.vue";

export default {
  components: {
    EditInfo
  },
  props: {
    memberId: {
      type: Number,
      required: true
    },
    name: {
      type: String,
      default: null
    },
    phone: {
      type: String,
      default: null
    },
    email: {
      type: String,
      default: null
    },
    dob: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      editInfo: {
        open: false,
        data: null
      }
    }
  },
  methods: {
    handleEditInfo() {
      this.editInfo.open = true
    }
  },
}
</script>

<style scoped>
.border {
  border: 1px solid #EEEEEE !important;
}
</style>